export default __webpack_public_path__ + "static/jeanlucweb-bold_broad-6d4891f1d3e0cc3e7b79a6e2b4cbc0bd.woff";